var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "image_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.565,
    height: 101.565,
    viewBox: "0 0 101.565 101.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61978",
    "data-name": "Path 61978",
    d: "M0,0H101.565V101.565H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-button",
    transform: "translate(11.239 11.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104565",
    "data-name": "Group 104565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64211",
    "data-name": "Path 64211",
    d: "M39.543,0A39.543,39.543,0,1,0,79.087,39.543,39.543,39.543,0,0,0,39.543,0ZM56.2,40.8a2.825,2.825,0,0,1-1.268,1.268v.014l-22.6,11.3a2.825,2.825,0,0,1-4.087-2.542v-22.6a2.825,2.825,0,0,1,4.087-2.528l22.6,11.3A2.824,2.824,0,0,1,56.2,40.8Z",
    fill: "#03e67c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlaceholder);
export default __webpack_public_path__ + "static/media/video_placeholder.ae917519533123a24312212eaae9fcc8.svg";
export { ForwardRef as ReactComponent };